module.exports = __webpack_public_path__ + "img/germany-endocrine-nutritional-metabolic-diseases-female.00d96cea.png";